/**
 * 월드 좌표 & 지형 헬퍼 — 전부 순수 결정적 함수 (RNG 없음).
 * 지형 높이(heightAt)는 렌더링과 sim이 공유하는 단일 출처. Math.sin 기반이라 결정적.
 * row 0 = 북쪽 끝(마왕령), 남쪽(+z)이 왕국.
 */
import { WORLD } from '@villager/shared';

const { GW, GD, TILE } = WORLD;

export const TERR_W = GW * TILE;
export const TERR_D = GD * TILE;
export const SOUTH = TERR_D / 2;

export function colX(c: number): number {
  return -TERR_W / 2 + (c + 0.5) * TILE;
}
export function rowZ(r: number): number {
  return -TERR_D / 2 + (r + 0.5) * TILE;
}
export function frontZ(frontRow: number): number {
  return -TERR_D / 2 + frontRow * TILE;
}

/** 월드 좌표 → 타일 (c,r). 범위 밖이면 음수/초과값 그대로 반환하니 호출측에서 검사. */
export function tileAt(x: number, z: number): { c: number; r: number } {
  return {
    c: Math.floor((x + TERR_W / 2) / TILE),
    r: Math.floor((z + TERR_D / 2) / TILE),
  };
}

// ── 결정적 지형 높이 (프로토타입 heightAt 이식) ──
function hash(x: number, y: number): number {
  const n = Math.sin(x * 127.1 + y * 311.7) * 43758.5453;
  return n - Math.floor(n);
}
function vnoise(x: number, y: number): number {
  const xi = Math.floor(x);
  const yi = Math.floor(y);
  const xf = x - xi;
  const yf = y - yi;
  const s = (t: number): number => t * t * (3 - 2 * t);
  const u = s(xf);
  const v = s(yf);
  const a = hash(xi, yi);
  const b = hash(xi + 1, yi);
  const c = hash(xi, yi + 1);
  const d = hash(xi + 1, yi + 1);
  return a + (b - a) * u + (c - a) * v + (a - b - c + d) * u * v;
}
export function heightAt(x: number, z: number): number {
  return vnoise(x * 0.012 + 7, z * 0.012 + 3) * 5 + vnoise(x * 0.05 + 17, z * 0.05 + 11) * 1.2;
}
